// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let React = require("react");
let IconV5 = require("../../common/Components/IconV5.bs.js");
let Tooltip = require("../../common/Components/Tooltip.bs.js");
let ButtonsV5 = require("../../common/Components/ButtonsV5.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let ReactContentLoader = require("react-content-loader").default;
let FragmentErrorBoundary = require("../../common/Components/FragmentErrorBoundary.bs.js");
let VisuallyHidden = require("@reach/visually-hidden").default;
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let MyClientsWidgetComponentsMatchesSummary_matchable_graphql = require("../../../__generated__/MyClientsWidgetComponentsMatchesSummary_matchable_graphql.bs.js");

function MyClientsWidgetComponents$HelperIcon(props) {
  let label = props.label;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(VisuallyHidden, {
        children: label
      }),
      JsxRuntime.jsx("span", {
        children: JsxRuntime.jsx(Tooltip.make, {
          label: label,
          children: JsxRuntime.jsx("span", {
            children: JsxRuntime.jsx(IconV5.make, {
              icon: props.icon,
              size: 17,
              className: "align-baseline inline-block text-gray-400"
            })
          })
        }),
        "aria-hidden": true
      })
    ]
  });
}

let HelperIcon = {
  make: MyClientsWidgetComponents$HelperIcon
};

function MyClientsWidgetComponents$HiddenAddressIcon(props) {
  return JsxRuntime.jsx(MyClientsWidgetComponents$HelperIcon, {
    label: "Hidden Address",
    icon: "lock"
  });
}

let HiddenAddressIcon = {
  make: MyClientsWidgetComponents$HiddenAddressIcon
};

function MyClientsWidgetComponents$AutoNotifyIcon(props) {
  return JsxRuntime.jsx(MyClientsWidgetComponents$HelperIcon, {
    label: "Auto-notify is on",
    icon: "bell"
  });
}

let AutoNotifyIcon = {
  make: MyClientsWidgetComponents$AutoNotifyIcon
};

function MyClientsWidgetComponents$MatchesSummary$Skeleton(props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(ReactContentLoader, {
      children: JsxRuntime.jsx("rect", {
        height: "10",
        width: "65",
        rx: "3",
        ry: "3",
        x: "0",
        y: "3"
      }),
      height: "16px",
      width: "65px"
    }),
    className: "text-sm leading-5"
  });
}

let Skeleton = {
  make: MyClientsWidgetComponents$MatchesSummary$Skeleton
};

let convertFragment = MyClientsWidgetComponentsMatchesSummary_matchable_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetComponentsMatchesSummary_matchable_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetComponentsMatchesSummary_matchable_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetComponentsMatchesSummary_matchable_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetComponentsMatchesSummary_matchable_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function label(matchesCount) {
  if (matchesCount !== 0) {
    if (matchesCount !== 1) {
      return matchesCount.toString() + ` matches`;
    } else {
      return "1 match";
    }
  } else {
    return "No matches yet";
  }
}

function MyClientsWidgetComponents$MatchesSummary$Inner(props) {
  let matchable = RescriptRelay_Fragment.useFragment(MyClientsWidgetComponentsMatchesSummary_matchable_graphql.node, convertFragment, props.matchable);
  let matchesCount = matchable.numberOfMatches.totalCount;
  let matchesLabel = label(matchesCount);
  return JsxRuntime.jsx("div", {
    children: matchesCount !== 0 ? JsxRuntime.jsx(ButtonsV5.Link.make, {
        href: `/my_clients/` + props.clientId + `#matches`,
        className: "text-sm font-medium",
        children: matchesLabel
      }) : JsxRuntime.jsx("div", {
        children: matchesLabel,
        className: "text-gray-500"
      }),
    className: "text-sm leading-5"
  });
}

let Inner = {
  Fragment: Fragment,
  label: label,
  make: MyClientsWidgetComponents$MatchesSummary$Inner
};

function MyClientsWidgetComponents$MatchesSummary(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "matches",
    children: JsxRuntime.jsx(React.Suspense, {
      children: JsxRuntime.jsx(MyClientsWidgetComponents$MatchesSummary$Inner, {
        matchable: props.matchable,
        clientId: props.clientId
      }),
      fallback: JsxRuntime.jsx(MyClientsWidgetComponents$MatchesSummary$Skeleton, {})
    })
  });
}

let MatchesSummary = {
  Link: undefined,
  Skeleton: Skeleton,
  Inner: Inner,
  make: MyClientsWidgetComponents$MatchesSummary
};

function areaPreview(areas, maxVisibleOpt) {
  let maxVisible = maxVisibleOpt !== undefined ? maxVisibleOpt : 2;
  let visibleAreas = areas.filter((param, index) => index < maxVisible);
  let hiddenAreasCount = areas.length - visibleAreas.length | 0;
  if (visibleAreas.length === 0) {
    return;
  }
  let preview = Utils.$$Array.joinWith(", ", visibleAreas);
  if (hiddenAreasCount > 0) {
    return preview + ` +` + hiddenAreasCount.toString();
  } else {
    return preview;
  }
}

exports.HelperIcon = HelperIcon;
exports.HiddenAddressIcon = HiddenAddressIcon;
exports.AutoNotifyIcon = AutoNotifyIcon;
exports.MatchesSummary = MatchesSummary;
exports.areaPreview = areaPreview;
/* Utils Not a pure module */
